import { ThirdPartyTracksResponse } from './types';

export async function fetchTracksBySpotifyPlaylistId({
  playlistId,
}: {
  playlistId: string;
}): Promise<ThirdPartyTracksResponse> {
  const response = await fetch(
    `/api/proxy/v3/music/spotify/playlist/tracks?playlistId=${playlistId}`,
    {
      method: 'GET',
      credentials: 'same-origin',
    }
  );
  if (response.ok) {
    return response.json();
  }
  throw new Error(`Could not fetch playlist's tracks`);
}
